import { useState, useEffect } from 'react';
import { fetchGeolocation } from '../utils/apiService';

// Module-level cache so multiple components share a single API call
let cachedGeoData = null;
let fetchPromise = null;

/**
 * Custom hook to fetch and store geolocation data (cached globally)
 */
export const useGeolocation = () => {
  const [geoData, setGeoData] = useState(cachedGeoData);
  const [loading, setLoading] = useState(!cachedGeoData);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cachedGeoData) {
      setGeoData(cachedGeoData);
      setLoading(false);
      return;
    }

    const getGeolocation = async () => {
      try {
        setLoading(true);
        // Deduplicate: reuse in-flight promise if another component already started fetching
        if (!fetchPromise) {
          fetchPromise = fetchGeolocation();
        }
        const data = await fetchPromise;

        if (data && data.isSuccess) {
          cachedGeoData = data;
          setGeoData(data);
        } else {
          setError('Failed to fetch location');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getGeolocation();
  }, []);

  return { geoData, loading, error };
};
